/**
 * Custom Badge component based on Vuexy design.
 * Provides consistent styling and tonal variant support.
 */

// MUI Imports
import MuiBadge from '@mui/material/Badge';
import type { BadgeProps } from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

/**
 * Custom Badge props with tonal variant support
 */
export type CustomBadgeProps = BadgeProps & {
  tonal?: 'true' | 'false';
};

const Badge = styled(MuiBadge)<CustomBadgeProps>(({ tonal, color }) => {
  return {
    ...(tonal === 'true' && {
      '& .MuiBadge-badge.MuiBadge-standard': {
        color: `var(--mui-palette-${color}-main)`,
        backgroundColor: `var(--mui-palette-${color}-lightOpacity)`,
      },
    }),
  };
});

/**
 * Custom Badge component with Vuexy styling.
 * @param props - Badge props with custom options
 */
const CustomBadge = (props: CustomBadgeProps) => <Badge {...props} />;

export default CustomBadge;
